module.exports = __webpack_public_path__ + "img/hero-human-animated.468a582c.gif";